import {
  NativeSelect,
  NativeSelectField,
  NativeSelectLabel,
  NativeSelectRoot,
} from '@kustom-checkout/morpheus';

interface SelectFieldProps {
  id: string;
  label: string;
  value: string;
  options: readonly string[];
  onChange: (value: string) => void;
}

export function SelectField({
  id,
  label,
  value,
  options,
  onChange,
}: SelectFieldProps) {
  // Every field is settable from the URL, so a value outside the shortlist has
  // to stay selectable rather than render as an empty select.
  const choices = options.includes(value) ? options : [value, ...options];

  return (
    <NativeSelectRoot
      id={id}
      value={value}
      onValueChange={(event) => onChange(event.target.value)}
    >
      {/* Matches TextField: muted label, muted outline. See the note there. */}
      <NativeSelectLabel>
        <span className="text-on-surface-muted font-normal">{label}</span>
      </NativeSelectLabel>
      <NativeSelectField className="border-outline-muted">
        <NativeSelect className="font-normal">
          {choices.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </NativeSelect>
      </NativeSelectField>
    </NativeSelectRoot>
  );
}
